import axios from 'axios'

const getFileNameFromContentDisposition = contentDisposition => {
  if (!contentDisposition || typeof contentDisposition !== 'string') {
    return null
  }

  const utf8NameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8NameMatch?.[1]) {
    return decodeURIComponent(utf8NameMatch[1].trim().replace(/\"/g, ''))
  }

  const basicNameMatch = contentDisposition.match(/filename=([^;]+)/i)
  if (basicNameMatch?.[1]) {
    return basicNameMatch[1].trim().replace(/^\"|\"$/g, '')
  }

  return null
}

const AxiosStream = {
  download: async (filename, ext, { url, params }) => {
    const response = await axios.get(url, {
      params,
      responseType: 'blob'
    })

    const contentDispositionHeader =
      response.headers?.['content-disposition'] ||
      response.headers?.['Content-Disposition']

    const serverFileName = getFileNameFromContentDisposition(
      contentDispositionHeader
    )
    const blob = new Blob([response.data])
    const objectURL = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectURL
    link.download = serverFileName || `${filename}.${ext}`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(objectURL)
  }
}

export default AxiosStream
